import { Flex, message, Spin } from 'antd';
import { fetchMyPermissions, logout } from 'api/auth';
import { AdminContext } from 'constants/contexts';
import usePersistedState from 'hooks/usePersistedState';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { errorHandling } from 'utils';
import { captureException } from 'utils/errors';

const initialUserState = {
  first_name: '',
  last_name: '',
  email: '',
  pk: null,
  authToken: null,
  permissions: [],
};
function AdminProvider({ children }) {
  const [organization, setOrganization] = usePersistedState(null, 'admin-provider/organization');
  const [user, setUserInfo] = usePersistedState(initialUserState, 'admin-provider/user');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user.authToken) {
      setLoading(true);
      // To ensure persisted token is loaded
      // TODO: investigate and find a more robust solution.
      setTimeout(() => {
        fetchMyPermissions().then((res) => {
          if (JSON.stringify(res.message?.permissions) !== JSON.stringify(user.permissions)) {
            setUserInfo((d) => ({ ...d, permissions: res.message?.permissions }));
          }
          setLoading(false);
        }).catch((e) => {
          captureException(e);
          setLoading(false);
          if (e.response?.status === 401) {
            message.error('Authentication failed!');
            logoutUser();
          }
        });
      }, 100);
    }
  }, [user.authToken, organization?.id]);

  const logoutUser = useCallback(() => {
    logout().then((res) => {
      setUserInfo(initialUserState);
      setOrganization(null);
    }).catch((e) => {
      captureException(e);
      errorHandling(e);
      if (e.response?.status === 401) {
        setUserInfo(initialUserState);
      }
    });
  }, []);

  // Force logout once due to bug fix
  // useEffect(() => {
  //   const FORCE_LOGOUT_FLAG = 'admin-force-logout-completed';

  //   if (!localStorage.getItem(FORCE_LOGOUT_FLAG) && user.authToken) {
  //     // Force logout and redirect to root
  //     logoutUser();
  //     window.location.href = '/login';

  //     // Set flag to prevent future force logouts
  //     localStorage.setItem(FORCE_LOGOUT_FLAG, 'true');
  //   }
  // }, [user.authToken, logoutUser]);

  const contextValue = useMemo(() => ({
    user,
    organization,
    isLoggedIn: Boolean(user.authToken),
    organizationId: organization?.id,
    permissions: user.permissions,
    setOrganization,
    setUser: (data) => {
      setUserInfo((d) => ({ ...d, ...data }));
    },
    logoutUser,
  }), [user, organization, setOrganization, setUserInfo, logoutUser]);

  return (
    <AdminContext.Provider value={contextValue}>
      <Flex
        justify="center"
        align="center"
        className="h-[100vh]"
        style={{
          display: loading ? 'flex' : 'none',
        }}
      >
        <Spin size="large" id="initial-loading" />
      </Flex>
      <div
        style={{
          display: loading ? 'none' : 'block',
        }}
      >
        {children}
      </div>
    </AdminContext.Provider>
  );
}

export default AdminProvider;
